exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".KioskSpinner__processingLoader___1A0ncLET {\n  width: 238px;\n  height: 238px;\n  margin: 0 auto;\n  animation: KioskSpinner__loader___34vx7Sfn 3s linear infinite;\n}\n.KioskSpinner__processingLoader___1A0ncLET .KioskSpinner__loadingIcon___1BJxM6_a {\n    width: 238px;\n    height: 238px;\n}\n.KioskSpinner__processingText___2btz8eV7 {\n  margin-top: 52px;\n}\n@keyframes KioskSpinner__loader___34vx7Sfn {\nfrom {\n    transform: rotateZ(0);\n}\n50% {\n    transform: rotateZ(180deg);\n}\nto {\n    transform: rotateZ(360deg);\n}\n}\n", ""]);
// Exports
exports.locals = {
	"processingLoader": "KioskSpinner__processingLoader___1A0ncLET",
	"loader": "KioskSpinner__loader___34vx7Sfn",
	"loadingIcon": "KioskSpinner__loadingIcon___1BJxM6_a",
	"processingText": "KioskSpinner__processingText___2btz8eV7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/kiosk/components/KioskSpinner.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = LvEs
// module chunks = 3